import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-数字孪生",
  "use": "icon-数字孪生-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-数字孪生\">\r\n<path d=\"M179.2,50.5L107.7,9.2c-2.9-1.6-6.6-1.6-9.5,0L26.8,50.5c-2.9,1.7-4.7,4.8-4.7,8.2v82.5c0,3.4,1.8,6.6,4.7,8.2l71.5,41.3\r\n\tc1.5,0.8,3,1.3,4.6,1.3l0,0h0.1c1.6,0,3.3-0.5,4.7-1.3l71.5-41.3c2.9-1.7,4.7-4.8,4.7-8.2V58.7C184,55.4,182.1,52.3,179.2,50.5z\r\n\t M76.4,84.6l21.5-12.5v20.4l-21.5,15.9V84.6z M108,72.2l21.5,12.4v23.8L108,92.5V72.2z M103,101.4l22.3,16.5L103,130.7l-22.3-12.9\r\n\tL103,101.4z M65,85.6v30.9c0,3.3,1.7,6.4,4.6,8.1l27.6,15.9v36.6l-63.9-36.6l-0.3-74.4L65,85.6z M108.6,140.6l27.6-16\r\n\tc2.9-1.6,4.6-4.7,4.6-8V86.1l31.8-19.3l0.3,73.3l-64.3,37.1C108.6,177.2,108.6,140.6,108.6,140.6z M136.4,75.5\r\n\tc-0.1,0-0.1-0.1-0.2-0.1l-28.7-16.6c-1.5-0.9-3-1.3-4.6-1.3c-1.6,0-3.2,0.4-4.6,1.3L69.9,75.3L39.1,56.5l63.6-37.1l64.9,37.2\r\n\tL136.4,75.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/数字孪生.svg
// module id = 1LtC
// module chunks = 15